// Anything stored under this prefix in localStorage is preserved across
// logout (table column layouts, saved filters, etc.). Use `pref.` for any
// user-preference key that should survive sign-out.
export const PREF_STORAGE_PREFIX = "pref.";

/**
 * Wipe localStorage the way logout expects, but keep any key whose name
 * starts with PREF_STORAGE_PREFIX. Call this instead of `localStorage.clear()`
 * from logout / unauthorized-redirect code paths.
 */
export const clearAppStorage = (): void => {
  try {
    const preserved: Array<[string, string]> = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (key.startsWith(PREF_STORAGE_PREFIX)) {
        const value = localStorage.getItem(key);
        if (value !== null) preserved.push([key, value]);
      }
    }
    localStorage.clear();
    for (const [key, value] of preserved) {
      localStorage.setItem(key, value);
    }
  } catch {
    // Storage disabled / quota / private mode — safe to swallow;
    // logout should still redirect regardless.
  }
};
